import { disposables as o } from "../utils/disposables.js";
import { getOwnerDocument as u$1 } from "../utils/owner.js";
import { useIsTopLayer as x } from "./use-is-top-layer.js";
import { useIsoMorphicEffect as n } from "./use-iso-morphic-effect.js";
let f = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map();
function h(t) {
  var e;
  let r = (e = u.get(t)) != null ? e : 0;
  return u.set(t, r + 1), r !== 0 ? () => m(t) : (f.set(t, { "aria-hidden": t.getAttribute("aria-hidden"), inert: t.inert }), t.setAttribute("aria-hidden", "true"), t.inert = true, () => m(t));
}
function m(t) {
  var i;
  let r = (i = u.get(t)) != null ? i : 1;
  if (r === 1 ? u.delete(t) : u.set(t, r - 1), r !== 1) return;
  let e = f.get(t);
  e && (e["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", e["aria-hidden"]), t.inert = e.inert, f.delete(t));
}
function y(t, { allowed: r, disallowed: e } = {}) {
  let i = x(t, "inert-others");
  n(() => {
    var d, c;
    if (!i) return;
    let a = o();
    for (let n2 of (d = e == null ? void 0 : e()) != null ? d : []) n2 && a.add(h(n2));
    let s = (c = r == null ? void 0 : r()) != null ? c : [];
    for (let n2 of s) {
      if (!n2) continue;
      let l = u$1(n2);
      if (!l) continue;
      let o2 = n2.parentElement;
      for (; o2 && o2 !== l.body; ) {
        for (let p of o2.children) s.some((E) => p.contains(E)) || a.add(h(p));
        o2 = o2.parentElement;
      }
    }
    return a.dispose;
  }, [i, r, e]);
}
export {
  y as useInertOthers
};
